export default __webpack_public_path__ + "static/cms-2-cae10ecc12ae8e4496f5a721acdf50aa.png";